import envConfig from '../../../config';
import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';
import { EmployeeById, RoleDetailById } from '../api-types';

export const name: string = 'admin';

//=============================================//
//=============== Actions Types ===============//
//=============================================//

export const types = {
    GET_ROLE: name + '/GET_ROLE',
    ADD_ROLE: name + '/ADD_ROLE',
    REMOVE_ROLE: name + '/REMOVE_ROLE',
    MERGE_ROLE: name + '/MERGE_ROLE',
    GET_ALL_ROLES: name + '/GET_ALL_ROLES',
    GET_ALL_EMPLOYEES: name + '/GET_ALL_EMPLOYEES',
    GET_EMPLOYEE: name + '/GET_EMPLOYEE',
};

interface AdminState {
    employees: EmployeeById;
    roles: RoleDetailById;
    rights: string[];
}

const initialState: AdminState = {
    employees: {} as EmployeeById,
    roles: {} as RoleDetailById,
    rights: [],
};

const reducer = (state = initialState, action) => {
    const payload = action.payload;
    // const parameters = action.parameters;
    switch (action.type) {
        case types.GET_ALL_ROLES:
            const datas = payload.reduce(
                (res, item) => {
                    const rights = res.rights;
                    item.rights.forEach((element) => {
                        if (!rights[element.tag]) {
                            rights[element.tag] = element.tag;
                        }
                    });
                    return {
                        ...res,
                        roles: { ...res.roles, [item.uuid]: item },
                        rights,
                    };
                },
                { roles: {}, rights: {} },
            );
            return {
                ...state,
                roles: datas.roles,
                rights: Object.values(datas.rights),
            };
        case types.GET_EMPLOYEE:
        case types.ADD_ROLE:
        case types.REMOVE_ROLE:
        case types.MERGE_ROLE:
            return {
                ...state,
                employees: {
                    ...state.employees,
                    [payload.id]: payload,
                },
            };
        default:
            return state;
    }
};
export default reducer;

//================================================//
//=============== Actions Creators ===============//
//================================================//

export const actions = {
    getAllRoles: () =>
        fetchAction(
            CoreAPIService.get(`/internal/backoffice/role`, null, { credential: true }, envConfig.id_url),
            types.GET_ALL_ROLES,
            {},
        ),
    getAllEmployees: () =>
        fetchAction(
            CoreAPIService.get(`/internal/backoffice/employee`, null, { credential: true }, envConfig.id_url),
            types.GET_ALL_EMPLOYEES,
            {},
        ),
    getEmployeeByID: (id: string) =>
        fetchAction(
            CoreAPIService.get(`/internal/backoffice/employee/${id}`, null, { credential: true }, envConfig.id_url),
            types.GET_EMPLOYEE,
            {},
        ),
    getRole: (uuidRole: string) =>
        fetchAction(
            CoreAPIService.get(`/internal/backoffice/role/${uuidRole}`, null, { credential: true }, envConfig.id_url),
            types.GET_ROLE,
            {},
        ),
    addRoleToEmployee: (uuidEmployee: string, uuidRole: string, expires: any = 'null') =>
        fetchAction(
            CoreAPIService.put(
                `/internal/backoffice/employee/${uuidEmployee}/role/${uuidRole}/target/null/expires/${expires}`,
                null,
                { credential: true },
                envConfig.id_url,
            ),
            types.ADD_ROLE,
            { uuidEmployee, uuidRole },
        ),
    removeRoleToEmployee: (uuidEmployee: string, uuidRole: string) =>
        fetchAction(
            CoreAPIService.delete(
                `/internal/backoffice/employee/${uuidEmployee}/role/${uuidRole}/target/null`,
                null,
                { credential: true },
                envConfig.id_url,
            ),
            types.REMOVE_ROLE,
            { uuidEmployee, uuidRole },
        ),
    mergeRoleBetweenEmployee: (uuidEmployeeSource: string, uuidEmployeeTarget: string, overwrite: boolean) =>
        fetchAction(
            CoreAPIService.post(
                `/internal/backoffice/role/merge`,
                {
                    source: uuidEmployeeSource,
                    target: uuidEmployeeTarget,
                    overwrite,
                },
                { credential: true },
                envConfig.id_url,
            ),
            types.MERGE_ROLE,
            {},
        ),
};

const localState = (state: any): AdminState => state[name] || initialState;
export const selectors = {
    getEmployees: (state) => localState(state).employees,
    getRoles: (state) => localState(state).roles,
    getRolesArray: (state) => Object.values(localState(state).roles),
    getRights: (state) => localState(state).rights,
};
